// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"IppicaTicketSistema_wrapper__i4jSw","bigWrapper":"IppicaTicketSistema_bigWrapper__Hh3JE","list":"IppicaTicketSistema_list__kHxO8"};